import { ref, computed, onMounted, onUnmounted, watch } from 'vue';

export const openMobileMenu = ref(false);
export const openMobileMenuTransition = ref(false);

export function toggleMobileMenu() {
    openMobileMenuTransition.value = true;
    openMobileMenu.value = !openMobileMenu.value;

    setTimeout(() => {
        openMobileMenuTransition.value = false;
    }, 500);
}
